import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core'

import { UntypedFormBuilder } from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router'
import { DatePipe } from '@angular/common'
import { MessageService, SortEvent } from 'primeng/api'
import { NgxSpinnerService } from 'ngx-spinner'
import { Customsort } from 'src/app/carefinity/directives/customsort'
import {
  DataPageOfPatient,
  Patient,
  DataPageOfSignificantEvents,
  SignificantEvents,
  UiPreferences,
} from '../../../../../api/models'
import {
  PatientService,
  ColumnChooserService,
  AppSettingService,
} from '../../../../../api/services'
import { CareFinitySession } from '../../../../services/CareFinitySession'

@Component({
  selector: 'app-sig-list',
  templateUrl: './sig-list.component.html',
  styleUrls: ['./sig-list.component.css'],
})
export class SigListComponent implements OnInit {
  Item = 'Significant Events'
  sigevents: DataPageOfSignificantEvents
  selectedPatient: SignificantEvents
  Lastpageindex: number = 1
  rows: number
  _selectedColumns: any[]
    txtSearch: string = '';
   cols: any[]
    othercol: any[]
    pageSize: number = 0;
    pageNumber: number = 1
    sortby: string = 'Desc'
    preferences: UiPreferences = {};
    showRecords: boolean = false;

    setPrintFlag: boolean = false;
    showPatientDemographicPrint: boolean = false;
    patientFullName;
  constructor(
    private fb: UntypedFormBuilder,
    private router: Router,
    private ptservice: PatientService,
    private columnchooserservice: ColumnChooserService,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
    private _spinnerService: NgxSpinnerService,
      private cstsort: Customsort,
      private messageService: MessageService,
      private appSetting: AppSettingService


  ) {}
    ngOnInit() {       
    this.pageSize = CareFinitySession?.applicationSettings?.apiDataPageSize;
    this.cols = [
        { field: 'date', header: 'Sig.Date      ' },
      { field: 'enc_nbr', header: 'Enc#' },
      { field: 'event_description', header: 'Event Description' },
      { field: 'sig_msg', header: 'Sig. Message' },
      { field: 'pre_modification', header: 'Pre Modification' },
      { field: 'post_modification', header: 'Post Modification' },
      { field: 'created_by', header: 'Created By' },
       ]
        this.patientFullName = sessionStorage.getItem('ptName');
        //this.EventList(1, 'Desc');
        this.loadSignificantEventsList(this.pageNumber, this.sortby);

        this.appSetting
            .appSettingGetPracticeSettings$Response()
            .subscribe((res) => {
                this.showPatientDemographicPrint = res.body.enablePatientDemographicPrint;
                if (CareFinitySession?.user.roles.patientRecordsPrint == true && this.showPatientDemographicPrint == true) {
                    this.setPrintFlag = true;
                }
                else {
                    this.setPrintFlag = false;
                }
            })

        const storedPreferences = localStorage.getItem('uiPreferences');
        if (storedPreferences) {
            this.preferences = JSON.parse(storedPreferences);

            this.Item = this.preferences?.significantEvents || 'Significant Events';
        }
  }

  customSort(event: SortEvent, num: number) {
    this.sigevents.data = this.cstsort.generalcustomSort( event,  this.sigevents.data)
    }


    loadSignificantEventsList(pageNumber: number, sortbydirection: string) {
        this.ptservice
            .patientGetSignificantList({ PatientId: sessionStorage.getItem('ptId'), emrpracticeId: localStorage.getItem('EmrPracticeId'), pageNumber: pageNumber,sortbydirection: sortbydirection, searchText: this.txtSearch})
            .subscribe(
                (respsigevents) => {
                    console.log(respsigevents)
                    this.sigevents = respsigevents;
                    this.rows = this.sigevents.pageSize;

                    if (this.sigevents.totalRecords > 0)
                    {
                        this.showRecords = true;
                    } else {
                        this.showRecords = false;
                    }              
                },
                (err) => {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: err?.error,
                        life: 3000,
                    })
                },
            )
    }



  EventList(pageNumber: number, sortbydirection: string) {
    this.ptservice
      .patientGetSignificantList({
        PatientId: sessionStorage.getItem('ptId'),
        emrpracticeId: localStorage.getItem('EmrPracticeId'),
        pageNumber: pageNumber,
      })
      .subscribe((result) => {
        this.sigevents = result

        this.rows = this.sigevents.pageSize
      })
    }


    searchSignificantEvents() {
        if (this.txtSearch.length > 1) {
            this.sigevents = null
            this.rows = null
            this.loadSignificantEventsList(this.pageNumber, this.sortby);
        }
    }


    clearSearch() {
        if (this.txtSearch.length >= 0 || this.txtSearch == '') {
            this.txtSearch = ''
            this.loadSignificantEventsList(this.pageNumber, this.sortby);
        }
    }

    printSignificantEvents() {


        var PrintAllergies = document.getElementById('PrintSignificantEvents_List') as HTMLElement
        const printWindow = window.open('', '_blank')
        if (printWindow) {
            const divContent = PrintAllergies.innerHTML
            printWindow.document.open()
            printWindow.document.write(
                '<html><head><title>Print::Significant Events List</title>',
            )
            // Adding CSS styling for alternate rows
            printWindow.document.write('<style type="text/css">')
            printWindow.document.write('#SignificantEvents_print_table_tbody tbody tr:nth-child(odd) {',
            )
            printWindow.document.write(' background-color: #f2f2f2;')
            printWindow.document.write('    }')
            printWindow.document.write(
                '    #SignificantEvents_print_table_tbody tbody tr:nth-child(even) {',
            )
            printWindow.document.write('        background-color: #e6e6e6;')
            printWindow.document.write('    }')
            printWindow.document.write('</style>')
            printWindow.document.write('</head><body>')
            printWindow.document.write(divContent)
            printWindow.document.write('</body><html>')
            printWindow.document.close()
            printWindow.focus()
            printWindow.print()
            printWindow.close()
        } else {
            console.error('Failed to open print window.')
        }
    }
}
